import * as React from 'react';
import { observer } from 'mobx-react';

import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';

@observer
export default class UserDisplayName extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;

  componentDidMount() {
    if (!this.uiStore.userProfile) {
      this.uiStore.loadUserProfile();
    }
  }

  render() {
    return (
      <span>{this.uiStore.userDisplayName}</span>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/UserDisplayName.tsx